import type CartPaymentInfo from "~/domains/payment/cart/CartPaymentInfo";
import type DiscountInfo from "../../DiscountInfo";
import type { DiscountInfoType } from "../../DiscountInfoType";
import type ServiceDiscountStrategy from "./ServiceDiscountStrategy";
import type CartServiceInfo from "~/domains/payment/cart/CartServiceInfo";
import { isServiceLawnCareProgram, isServiceWebDiscountEligible, roundPrice } from "~/utils/payment";

export default class WebServiceDiscountStrategy implements ServiceDiscountStrategy {
  getDiscountInfoType(): DiscountInfoType {
    return "web";
  }

  getDiscountInfo(cartServiceInfo: CartServiceInfo, cartPaymentInfo: CartPaymentInfo): DiscountInfo {
    const discountInfo: DiscountInfo = {
      type: "web",
      description: "",
      value: 0,
      amount: 0,
    };

    /* Web discount only applies if:
      - Has a Lawn Care Program in their services (or cart)
      - Is not part of a package
      - This program/service is not excluded from Web Discount
      - This service is a seasonal service.
    */
    if (
      cartPaymentInfo.services.some((service) => isServiceLawnCareProgram(service))
      && !isServicePackage(cartServiceInfo)
      && isServiceWebDiscountEligible(cartServiceInfo)
      && !cartServiceInfo.isMonthly
      && !cartServiceInfo.isInitialPayment
    ) {
      const webDiscount = cartPaymentInfo.franchiseDiscounts.find((franchiseDiscount) => franchiseDiscount.name === "WebDiscount");
      const webDiscountValue = webDiscount?.value ?? 0;

      discountInfo.description = `Web Discount (${webDiscountValue * 100}%) - ${cartServiceInfo.ServiceName}`;
      discountInfo.value = webDiscountValue;
      discountInfo.amount = roundPrice((cartServiceInfo.subtotal ?? 0) * (discountInfo.value), "nearest", 2);
    }

    return discountInfo;
  }

  getMonthlyDiscountInfo(cartServiceInfo: CartServiceInfo, cartPaymentInfo: CartPaymentInfo): DiscountInfo {
    const discountInfo: DiscountInfo = {
      type: "web",
      description: "",
      value: 0,
      amount: 0,
    };

    return discountInfo;
  }

  getInitialPaymentDiscountInfo(cartServiceInfo: CartServiceInfo, cartPaymentInfo: CartPaymentInfo): DiscountInfo {
    const discountInfo: DiscountInfo = {
      type: "web",
      description: "",
      value: 0,
      amount: 0,
    };

    return discountInfo;
  }
}
